// extracted by mini-css-extract-plugin
module.exports = {"search-input":"search-input-454be07b85dbc7dcb4508b262a00a62f"};